import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const optimaConfig: TSPConfig = {
  key: 'optima',
  name: 'Optima',
  category: TSPCategory.API_KEY,
  helpText: 'Please request an API key from your Optima representative.',
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default optimaConfig;
